
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "48px",
    "height": "48px",
    "viewBox": "0 0 48 48",
    "enable-background": "new 0 0 48 48",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "48",
        "height": "48"
      }
    },
    {
      "tag": "circle",
      "attrsMap": {
        "fill": "#B7C3D7",
        "cx": "24",
        "cy": "24",
        "r": "24"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#FFFFFF",
        "d": "M17.277,15.176v-2.338c-0.004-1.637,1.313-2.959,2.949-2.959h7.889c1.629,0,2.957,1.326,2.957,2.957v2.342\n\th-2.217v-2.342c0-0.405-0.336-0.741-0.74-0.741h-7.889c-0.42,0-0.742,0.323-0.742,0.743l0.002,2.338H17.277L17.277,15.176z\n\t M11.936,25.889l-0.324,10.221c-0.02,0.678,0.555,1.232,1.232,1.232h11.328h11.334c0.676,0,1.252-0.554,1.23-1.232L36.41,25.889\n\th-4.846v0.863c0,0.339-0.277,0.615-0.617,0.615h-1.969c-0.34,0-0.617-0.276-0.617-0.615v-0.863h-8.379v0.863\n\tc0,0.339-0.277,0.615-0.617,0.615h-1.969c-0.338,0-0.617-0.276-0.617-0.615v-0.863H11.936L11.936,25.889z M11.117,17.639\n\tl-0.371,5.665c-0.037,0.599,0.48,1.093,1.08,1.107h4.953v-0.862c0-0.338,0.279-0.615,0.617-0.615h1.969\n\tc0.34,0,0.617,0.277,0.617,0.615v0.862h8.379v-0.862c0-0.338,0.277-0.615,0.617-0.615h1.969c0.34,0,0.617,0.277,0.617,0.615v0.862\n\th4.951c0.598-0.017,1.117-0.509,1.078-1.107l-0.369-5.665c-0.045-0.676-0.555-1.232-1.232-1.232H12.348\n\tC11.67,16.406,11.16,16.963,11.117,17.639L11.117,17.639z"
      }
    }
  ]
})
    }
  